import { Img } from './Img';
import { IImgProps } from './Img.interfaces';

export default Img;
export { Img, IImgProps };
